export const nl_BL = {
  // Header/Sidebar
  user: "Gebruiker",
  users: "Gebruikers",
  installations: "Installaties",
  settings: "Instellingen",
  certificate: "Certificaat",
  main_settings: "Hoofdinstellingen",
  terminology: "Terminologie",
  equipment: "Apparatuur",
  security: "Beveiliging",
  tenants: "Huurders",
  collapse: "Inklappen",
  branding: "Branding",
  sign_out: "Uitloggen",
  hello: "Hallo!",
  reports: "Rapporten",

  // Misc
  save: "Opslaan",
  cancel: "Annuleren",

  // Installation Table
  status: "Status",
  clear: "Wissen",
  date: "Datum",
  technician: "Technicus",
  customer_phone: "Klantentelefoon",
  address: "Adres",
  unit: "Eenheid",
  city: "Stad",
  state_prov: "Staat/Prov",
  rooms_tested: "Geteste kamers",
  tested: "Getest",
  plan: "Abonnement",
  rows_per_page: "Regels per pagina:",
  recommended_short: "Aanbev.",
  notes: "Opmerkingen",

  // Certificate Branding Tab
  current_image: "Huidige afbeelding: ",
  using_default_logo: "Standaardlogo gebruiken",
  new_image: "Nieuwe afbeelding",
  branding_loading_error: "Fout bij laden branding. Probeer het later opnieuw.",
  upload_new_image: "Nieuwe afbeelding uploaden",
  clear_custom_image: "Aangepaste afbeelding wissen",
  clear_custom_color: "Aangepaste kleur wissen",
  brand_color: "Merkkleur",
  header_message: "Hoofdbericht",
  header_education_message: "Onderwijs Hoofdbericht",
  footer_education_message: "Onderwijs Voettekstbericht",
  preview: "Voorbeeld",
  file_must_be_less_than_size_limit: "Bestand moet kleiner zijn dan 30KB",

  // Certificate Headers
  congrats_message:
    "Uw WiFi-installatie is voltooid en is gecertificeerd door RouteThis!",
  installation_details: "Installatiedetails",
  wireless_speed_test: "Draadloze Snelheidstest",
  wireless_speed_test_hidespeedtest: "Wifisnelheidstest",
  wireless_performance: "Draadloze Prestatie",
  photos: "Foto's",
  signal_maps: "Signaal Kaarten",
  wifi_information: "Je wifisnelheid begrijpen",

  // Certificate Kamer Naams
  singular_room: "Room",
  room_type_bathroom: "Badkamer",
  room_type_bedroom: "Slaapkamer",
  room_type_dining_room: "Eetkamer",
  room_type_entry_or_hall: "Ingang of hal",
  room_type_garage: "Garage",
  room_type_kitchen: "Keuken",
  room_type_living_room: "Woonkamer",
  room_type_office: "Kantoor",
  room_type_other: "Andere",

  // Pod Name
  pod_1: "Mesh Pod",
  pod_2: "Toegangspunt",
  pod_3: "Mesh Node",
  pod_4: "Mesh Puck",
  pod_5: "Baken",
  pod_6: "Wifi versterker",
  pods_1: "Mesh Pods",
  pods_2: "Toegangspunten",
  pods_3: "Mesh Nodes",
  pods_4: "Mesh Pucks",
  pods_5: "Bakens",
  pods_6: "Wifi versterkers", //Plural form of Wifi versterker

  // Router Name
  router_1: "Router",
  router_2: "Modem",
  router_3: "Gateway",
  router_4: "Hub",
  router_5: "Residentiële Gateway",

  // Niveau Name
  level_1: "Niveau",
  level_2: "Verdieping",
  levels_1: "Niveaus",
  levels_2: "Verdiepingen",

  // a11y Labels
  go_to_homepage: "Ga naar startpagina",
  edit_user_x: "Bewerk gebruiker [X]",
  open_certificate_for_addr: "Certificaat openen voor [ADDR]",
  clear_all_filters: "verwijder alle filters",
  expand_sidebar: "Zijbalk uitklappen",
  current_tenant_branding_image: "Huidige merkafbeelding van huurder",
  new_tenant_branding_image: "Nieuwe Huurder Merkimago",

  // Certificate Pod Info
  recommended: "Aanbevolen",
  installed: "Geïnstalleerd",
  installed_singular: "Geïnstalleerd",
  total: "Totaal",

  // Certificate Signal Table
  front_building: "Voorkant van het Gebouw",
  speed: "Snelheid",
  video: "Video",
  rssi: "RSSI",
  rssi_description: "dBm",
  link: "Link",
  frequency_short: "Freq.",
  frequency_description: "MHz",
  channel_short: "Kanaal.",

  // Certificate Legende
  legend: "Legend",
  measured_speed: "Gemeten Snelheid",
  measured_speed_description: "Mbps",
  plan_speed: "Snelheid abonnement",

  // Certificate Speedtest Result
  speedtest_passed:
    "De snelheid ligt binnen de verwachte waarde voor de meeste toestellen. Niet alle draadloze apparaten kunnen de maximale snelheid van het abonnement bereiken. Zie hieronder voor individuele kamer tests.",
  speedtest_passed_hidespeedtest:
    "Geverifieerde internetsnelheid voor uw abonnement.",
  speedtest_failed:
    "Getest op een telefoon of tablet. Niet alle draadloze apparaten kunnen de maximale snelheid van het abonnement bereiken. Zie hieronder voor individuele kamer tests.",
  speedtest_24ghz:
    "Snelheidstest werd uitgevoerd op de 2.4GHz-band; lage snelheid gemeten.",
  speedtestmessages_strong:
    "De snelheid ligt binnen de verwachte waarde voor de meeste toestellen.",
  speedtestmessages_weak:
    "De snelheid ligt ver onder de verwachte waarde voor de meeste toestellen.",
  speedtestmessages_medium:
    "De snelheid ligt onder de verwachte waarde voor de meeste toestellen.",
  wifi_activities_highspeed_videos: "Meerdere 4K-video's",
  wifi_activities_highspeed_conferencing: "Videoconferentie",
  wifi_activities_highspeed_gaming: "Online gamen",
  wifi_activities_highspeed_music: "Streaming muziek",
  wifi_activities_lowspeed_conferencing: "Videoconferentie",
  wifi_activities_lowspeed_gaming: "Online gamen",
  wifi_activities_lowspeed_music: "Muziek streamen",
  wifi_activities_lowspeed_email: "E-mail & sociale media",
  speedTestIndicatorText_weak: "Zwakke wifi",
  speedTestIndicatorText_medium: "Vertraagde wifi",
  speedTestIndicatorText_strong: "Optimale wifi",
  signal_coverage: "Signaalbereik",
  signaltablemessage_title:
    "Activiteiten zijn van links naar rechts gerangschikt op basis van de vereiste signaalsterkte.",
  signaltablemessage_subtitle:
    "Als je een activiteit kan uitvoeren in de aangeduide kamer, kan je ook alle activiteiten rechts ervan uitvoeren.",
  alerts: "Meldingen",
  alertMessages_bandAlert:
    "Speedtest werd uitgevoerd op de 2.4GHz-band; lage snelheid gemeten.",
  alertMessages_lowSignalAlert:
    "Je verbinding hier is stabiel en laat je toe om e-mails te checken en sociale media te gebruiken, maar je zal niet de snelheden halen die in andere delen van je woning mogelijk zijn.",
  alertMessages_veryLowSignalAlert:
    "Je signaalsterkte is zeer zwak. Dit kan leiden tot trage laadtijden en onderbrekingen. Ga voor een betere ervaring naar een ander deel van je woning waar het signaal sterker is.",
  alertMessages_noAlert: "Geen meldingen op deze verdieping!",
  alertmessages_lowPodsAlert:
    "Omdat niet alle aanbevolen Wifi versterkers zijn geïnstalleerd, kan je een lagere snelheid ervaren naarmate je verder van de router verwijderd bent.",
  customLowPodsAlertString:
    "Omdat niet alle aanbevolen %PODSNAME zijn geïnstalleerd, kunt u een snelheidsvermindering ervaren naarmate u verder van de %ROUTERNAME komt.",

  // Reports Page
  reports_access_error:
    "Neem contact op met uw beheerder om deze pagina te zien",

  // Login/Reset Wachtwoord
  password: "Password",
  sign_in: "Inloggen",
  forgot_password: "Wachtwoord Vergeten",
  reset_password: "Wachtwoord Herstellen",
  reset_password_instructions:
    "Om uw wachtwoord te resetten, voert u uw e-mailadres in hierboven en we zullen instructies sturen, als het account bestaat.",
  sent_reset_password_code:
    "We hebben een code voor het resetten van het wachtwoord gestuurd naar [email] Voer die code en een nieuw wachtwoord in.",
  reset_code: "Reset Code",
  new_password: "Nieuw Wachtwoord",
  reenter_new_password: "Voer het nieuwe wachtwoord opnieuw in",
  must_include_email: "Moet e-mail bevatten",
  old_password: "Oud wachtwoord",
  set_new_password: "Stel nieuw wachtwoord in",
  password_expired: "Wachtwoord Verlopen",
  toggle_password_visibility: "Wachtwoord zichtbaarheid wisselen",
  change_your_password: "Verander je wachtwoord",
  change_password: "Wachtwoord veranderen",
  set_password: "Stel wachtwoord in",

  // Users List
  new_user: "Nieuwe gebruiker",
  edit_user: "Gebruiker bewerken",
  bulk_import: "Bulkimport",
  bulk_import_users: "Bulkimport Gebruikers",
  show_disabled_users: "Toon Uitgeschakelde Gebruikers",
  name: "Name",
  role: "Rol",
  roles: "Rollen",
  location: "Locatie",
  group: "Groep",
  manager: "Manager",
  download_bulk_template: "Download Bulk Sjabloon",
  user_id_email: "Gebruikers-ID (e-mail)",

  // Valid User roles
  user_role: "user",
  tenant_admin_role: "TenantAdmin",
  super_admin_role: "SuperAdmin",
  tenant_admin: "Huurder Admin",
  super_admin: "Super Admin",

  // Creëren/Bewerken User Modal
  email_required: "E-mail (Vereist)",
  first_name: "Voornaam",
  last_name: "Achternaam",
  force_password_reset: "Verplicht Wachtwoord Herstellen",
  resend_validation_code: "Verzend Validatiecode opnieuw",
  enable_user: "Schakel Gebruiker in",
  disable_user: "Schakel Gebruiker uit",
  certify: "Certificeer",
  unverified: "Niet geverifieerd",
  locked_out: "Uitgesloten",
  disabled: "Uitgeschakeld",
  reset_user_password_confirmation:
    "Weet je zeker dat je het wachtwoord van deze gebruiker wilt resetten?",
  resend_validation_code_confirmation:
    "Weet je zeker dat je de validatiecode opnieuw wilt verzenden?",
  cannot_disable_yourself: "Kan jezelf niet uitschakelen",
  cancel_changes: "Annuleer wijzigingen",

  // Snackbar Messages
  snackbar_disable_success: "Gebruiker succesvol uitgeschakeld:",
  snackbar_disable_error: "Fout bij het uitschakelen van gebruiker:",
  snackbar_enable_success: "Gebruiker succesvol ingeschakeld:",
  snackbar_enable_error: "Fout bij het inschakelen van gebruiker:",
  snackbar_password_reset_success:
    "Het wachtwoord voor de gebruiker is succesvol gereset:",
  snackbar_password_reset_error:
    "Fout bij het resetten van het wachtwoord voor gebruiker:",

  // Bulk Importeren Modal
  csv_format_requirements:
    "Uw CSV-formaat moet correct worden geformatteerd. Als u niet zeker weet wat het juiste formaat is, kunt u ook",
  csv_format_download_link: "hier een sjabloonbestand downloaden.",

  csv_format_error:
    "We konden het door u geüploade bestand niet verwerken, zorg ervoor dat uw bestand in het juiste formaat is en de koppen 'email' en 'manager_0' bevat.",
  select_csv: "Blader door CSV-bestand",
  import: "Import",
  file_too_large: "Bestand te groot (Maximum van IMPORT_LIMIT gebruikers)",
  required_headers_missing: "Verplichte koppen ontbreken: e-mail",
  user_import_starting:
    "Het importeren van gebruikers begint. U ontvangt binnen enkele minuten een e-mail met een importoverzicht.",
  change_file: "Bestand wijzigen",

  // Bulk Import Messaging
  bulk_processing_1: "Wij zijn het bestand aan het verwerken:",
  bulk_processing_2:
    "Zodra we klaar zijn, sturen we u een e-mail met alle details.",
  bulk_complete_1: "Voltooid:",
  bulk_complete_2: "is nu geüpload.",
  bulk_error:
    "Er is een fout opgetreden en uw bestand is niet naar de server geüpload. Controleer uw e-mail voor details.",
  bulk_thanks_header: "Bedankt voor het uploaden van uw bestand!",
  bulk_thanks_content:
    "We zijn nu bezig met het verwerken ervan, en zodra we klaar zijn, sturen we u een e-mail met alle details. U kunt ook de app in de gaten houden voor updates over de status van uw bestand.",

  // Tenant Main Settings
  email_language: "E-mail Taal",
  country: "Land",
  description_optional: "Beschrijving (Optioneel)",
  units_feet_meters: "Eenheid (Voeten, Meters)",
  certify_id: "Certificeer ID",
  resolve_id: "Los ID op",
  sms_settings: "SMS Instellingen",
  udp_flood_settings: "UDP Flood Instellingen",
  udp_flood_settings_absolute_ideal:
    "SLAAG Als de UDP Flood snelheid groter is dan (Mbps)",
  udp_flood_settings_absolute_minimum:
    "WAARSCHUWING Als de UDP Flood snelheid groter is dan (Mbps) ",
  udp_flood_settings_plan_multiple:
    "SLAAG Als de UDP Flood snelheid groter is dan (keer de geplande snelheid/max snelheid)",
  udp_flood_settings_absolute_plan_percentage:
    "WAARSCHUWING Als de UDP Flood snelheid groter is dan (% van de geplande snelheid/max snelheid)",
  sms_from: "SMS Van",
  sms_body: "SMS Inhoud",
  default_sms_body:
    "Uw wifi-installatie is voltooid en is gecertificeerd door [NAME]! \n Bekijk uw certificaat hier: [LINK]",
  sms_body_helper_text:
    "Certify zal deze boodschap naar de klant sturen. [LINK] zal worden vervangen door een link naar het certificaat (vereist). [NAME] wordt vervangen door de inhoud van het veld Naam (optioneel)",
  link_must_be_in_sms_body: "[LINK] moet in het SMS-bericht staan.",
  update_successful: "Update Succesvol",
  creation_successful: "Creatie Succesvol",

  // Tenant Terminology Settings
  term: "Term",
  example_usage: "Voorbeeld van Gebruik",
  customer_example_usage_1:
    "In overleg met de klant, bevestig het geselecteerde gebouw, of ga terug om het adres te bewerken.",
  customer_example_usage_2:
    "In overleg met de abonnee, bevestig het geselecteerde gebouw, of ga terug om het adres te bewerken.",
  router_example_usage_1: "Tik op de voorgestelde routerlocatie hieronder.",
  router_example_usage_2: "Tik op de voorgestelde modemlocatie hieronder.",
  router_example_usage_3: "Tik op de voorgestelde gatewaylocatie hieronder.",
  router_example_usage_4: "Tik op de voorgestelde hublocatie hieronder.",
  router_example_usage_5:
    "Tik op de voorgestelde locatie van de residentiële gateway hieronder.",
  level_example_usage_1: "Ga naar niveau 2 en tik op je locatie.",
  level_example_usage_2: "Ga naar verdieping 2 en tik op je locatie.",
  mesh_pod_example_usage_1:
    "Het schatten van de signaalsterkte en optimale plaatsing van de mesh pod.",
  mesh_pod_example_usage_2:
    "Het schatten van signaalsterkte en optimale plaatsing van het toegangspunt.",
  mesh_pod_example_usage_3:
    "Het schatten van signaalsterkte en optimale mesh node plaatsing.",
  mesh_pod_example_usage_4:
    "Het schatten van signaalsterkte en optimale plaatsing van de mesh puck.",
  mesh_pod_example_usage_5:
    "Het schatten van de signaalsterkte en optimale plaatsing van de beacon.",
  mesh_pod_example_usage_6:
    "Het schatten van de signaalsterkte en optimale plaatsing van de range extender.",
  wifi_example_usage_1: "WiFi Mapping",
  wifi_example_usage_2: "Wi-Fi Mapping",
  wifi_example_usage_3: "Wifi Mapping",
  wifi_example_usage_4: "WIFI Mapping",

  // Tenant Equipment Settings (Certify)
  router_options_1: "Router Opties",
  router_options_2: "Modem Opties",
  router_options_3: "Gateway Opties",
  router_options_4: "Hub Opties",
  router_options_5: "Residentiële Gateway Opties",
  new_router_options_1: "Nieuwe Router Opties",
  new_router_options_2: "Nieuwe Modem Opties",
  new_router_options_3: "Nieuwe Gateway-opties",
  new_router_options_4: "Nieuwe Hub-opties",
  new_router_options_5: "Nieuwe Residentiële Gateway-opties",
  mesh_pod_options_1: "Mesh Pod-opties",
  mesh_pod_options_2: "Toegangspunt-opties",
  mesh_pod_options_3: "Mesh Node-opties",
  mesh_pod_options_4: "Mesh Puck-opties",
  mesh_pod_options_5: "Beacon-opties",
  mesh_pod_options_6: "Range Extender-opties",
  new_mesh_pod_options_1: "Nieuwe Mesh Pod-opties",
  new_mesh_pod_options_2: "Nieuwe Access Point Opties",
  new_mesh_pod_options_3: "Nieuwe Mesh Node Opties",
  new_mesh_pod_options_4: "Nieuwe Mesh Puck Opties",
  new_mesh_pod_options_5: "Nieuwe Beacon Opties",
  new_mesh_pod_options_6: "Nieuwe Range Extender Opties",
  missing_required_router_info_1: "Ontbrekende Verplichte Router Informatie",
  missing_required_router_info_2: "Ontbrekende Verplichte Modem Informatie",
  missing_required_router_info_3: "Ontbrekende Verplichte Gateway Informatie",
  missing_required_router_info_4: "Ontbrekende Verplichte Hub Informatie",
  missing_required_router_info_5:
    "Ontbrekende Verplichte Residential Gateway Informatie",
  missing_required_mesh_pod_info_1: "Ontbrekende vereiste Mesh Pod Informatie",
  missing_required_mesh_pod_info_2:
    "Ontbrekende vereiste Access Point Informatie",
  missing_required_mesh_pod_info_3: "Ontbrekende vereiste Mesh Node Informatie",
  missing_required_mesh_pod_info_4: "Ontbrekende vereiste Mesh Puck Informatie",
  missing_required_mesh_pod_info_5: "Ontbrekende vereiste Beacon Informatie",
  missing_required_mesh_pod_info_6:
    "Ontbrekende vereiste Range Extender Informatie",
  display_name: "Weergavenaam",
  description: "Beschrijving",
  range_in_unit_1: "Bereik in Voeten",
  range_in_unit_2: "Bereik in Meters",
  area_in_unit_1: "Oppervlakte in Vierkante Voet",
  area_in_unit_2: "Oppervlakte in Vierkante Meter",
  default_active: "Standaard Actief",
  average_range: "Gemiddeld Bereik",
  certify_default: "Certificeer standaard",
  default: "Standaard",
  active: "Actief",
  one_option_must_be_default: "Eén optie moet standaard zijn",
  set_as_default: "Instellen als standaard",
  default_option_must_be_active: "Standaard optie moet actief zijn",
  deactivate: "Deactiveren",
  activate: "Activeren",
  name_is_required: "Naam is vereist",

  // Klant Name
  customer_1: "Customer",
  customer_2: "Abonnee",
  // Wifi Name
  wifi_1: "WiFi",
  wifi_2: "Wi-Fi",
  wifi_3: "Wifi",
  wifi_4: "WIFI",

  // Eenheden
  units_1: "Voeten",
  units_2: "Meters",

  // Misc
  confirm: "Bevestigen",
  units: "Units",
  region: "Regio",
  edit: "Edit",
  modified: "Gewijzigd",
  create: "Create",
  created: "Gecreëerd",
  routethis_app: "RouteDeze App",
  loading: "Laden...",
  redirecting: "Doorsturen...",
  error: "Fout ",
  close: "Sluiten",
  search: "Zoeken",
  all: "Alle",
  dismiss: "Afwijzen",

  // Languages
  en: "Engels (VS)",
  "en-GB": "Engels (GB)",
  da: "Deens",
  fi: "Fins",
  fr: "Frans",
  "fr-CA": "Frans (Canada)",
  de: "Duits",
  el: "Grieks",
  it: "Italiaans",
  pt: "Portugees",
  "pt-BR": "Portugees (Braziliëië)",
  es: "Spaans",
  "es-419": "Spaans (Latijns-Amerika)",
  sv: "Zweeds",
};

export const en_errors = {
  // Client-side validation errors
  incorrect_email_or_password:
    "Ongeldig e-mailadres of wachtwoord, of uitgeschakeld account. Probeer het opnieuw of neem contact op met een beheerder.",
  invalid_reset_code: "Ongeldige resetcode",
  password_minimum_requirements:
    "Uw wachtwoord moet minimaal 8 tekens lang zijn en minstens één kleine letter, één grote letter en één cijfer bevatten.",
  passwords_must_match: "Wachtwoorden moeten overeenkomen",
  must_include_new_password_email:
    "Moet nieuw wachtwoord en gebruikersemail bevatten",
  must_include_new_password_confirmation_code:
    "Moet nieuw wachtwoord en bevestigingscode bevatten",
  cannot_send_reset_code_without_email:
    "Kan reset code niet versturen zonder e-mail",
  must_enter_old_password: "Moet oude wachtwoord invoeren",
  must_enter_reset_code: "Moet reset code invoeren",
  must_enter_new_password: "Moet nieuw wachtwoord invoeren",
  passwords_cannot_begin_or_end_with_spaces:
    "Wachtwoorden mogen niet beginnen of eindigen met spaties",

  // Server-side errors
  "Gebruiker met die e-mail bestaat al": "Gebruiker met die e-mail bestaat al",
  "Probeer een andere weergavenaam": "Probeer een andere weergavenaam",
  "Wachtwoord mag geen eerder gebruikt wachtwoord zijn":
    "Wachtwoord mag geen eerder gebruikt wachtwoord zijn",
  "Ongeldige resetcode": "Ongeldige resetcode",
  "Onjuiste e-mail of wachtwoord, of uitgeschakelde account. Probeer het opnieuw of neem contact op met een beheerder.":
    "Onjuiste e-mail of wachtwoord, of uitgeschakelde account. Probeer het opnieuw of neem contact op met een beheerder.",
  "Ongeldige code opgegeven, vraag alstublieft opnieuw een code aan.":
    "Ongeldige code opgegeven, vraag alstublieft opnieuw een code aan.",
  "Wachtwoord mag niet beginnen of eindigen met spaties":
    "Wachtwoord mag niet beginnen of eindigen met spaties",
  "LimitExceededException - poginglimiet overschreden, probeer het alstublieft na enige tijd opnieuw.":
    "LimitExceededException - Poginglimiet overschreden, probeer het na enige tijd opnieuw.",
  "Gebruiker is niet geautoriseerd": "Gebruiker is niet geautoriseerd",
  "Uw sessie is verlopen. Meld u opnieuw aan met uw tijdelijke wachtwoord.":
    "Uw sessie is verlopen. Meld u opnieuw aan met uw tijdelijke wachtwoord.",
  "Interne Servicefout - Cognito Niet Beschikbaar":
    "Interne Servicefout - Cognito Niet Beschikbaar",
  "Interne Servicefout - Onbekende Fout":
    "Interne Servicefout - Onbekende Fout",
  "Moet Reset Code invoeren": "Moet resetcode invoeren",

  // Change Password Challenges
  set_password_challenge:
    "U moet een nieuw wachtwoord instellen de eerste keer dat u zich aanmeldt om veiligheidsredenen.",
  reset_password_challenge:
    "We hebben een code voor het opnieuw instellen van het wachtwoord gestuurd naar [EMAIL]. Voer die code en een nieuw wachtwoord in.",
  set_new_password_challenge:
    "Het beleid van uw bedrijf vereist dat uw wachtwoord na enige tijd verloopt. We hebben een code voor het opnieuw instellen van het wachtwoord gestuurd naar [EMAIL]. Voer die code en een nieuw wachtwoord in.",
  change_your_password_challenge:
    "Voer uw huidige wachtwoord en een nieuw wachtwoord hieronder in om het te wijzigen.",
  change_password_challenge: "Voer een nieuw wachtwoord in voor de gebruiker",
};

export const en_countries = {
  AF: "Afghanistan",
  AX: "Ålandeilanden",
  AL: "Albanië",
  DZ: "Algerije",
  AS: "Amerikaans Samoa",
  AD: "Andorra",
  AO: "Angola",
  AI: "Anguilla",
  AQ: "Antarctica",
  AG: "Antigua en Barbuda",
  AR: "Argentinië",
  AM: "Armenië",
  AW: "Aruba",
  AU: "Australië",
  AT: "Oostenrijk",
  AZ: "Azerbeidzjan",
  BS: "Bahamas",
  BH: "Bahrein",
  BD: "Bangladesh",
  BB: "Barbados",
  BY: "Wit-Rusland",
  BE: "België",
  BZ: "Belize",
  BJ: "Benin",
  BM: "Bermuda",
  BT: "Bhutan",
  BO: "Bolivia (Plurinationale Staat van)",
  BQ: "Bonaire, Sint Eustatius en Saba",
  BA: "Bosnië en Herzegovina",
  BW: "Botswana",
  BV: "Bouvet-eiland",
  BR: "Brazil",
  IO: "Brits Indische Oceaanterritorium",
  BN: "Brunei Darussalam",
  BG: "Bulgarije",
  BF: "Burkina Faso",
  BI: "Burundi",
  CV: "Kaapverdië",
  KH: "Cambodja",
  CM: "Kameroen",
  CA: "Canada",
  KY: "Kaaimaneilanden",
  CF: "Centraal-Afrikaanse Republiek",
  TD: "Tsjaad",
  CL: "Chili",
  CN: "China",
  CX: "Kersteiland",
  CC: "Cocos (Keeling) Eilanden",
  CO: "Colombia",
  KM: "Comoren",
  CG: "Congo",
  CD: "Congo, Democratische Republiek van de",
  CK: "Cook Eilanden",
  CR: "Costa Rica",
  CI: "Ivoorkust",
  HR: "Kroatië",
  CU: "Cuba",
  CW: "Curaçao",
  CY: "Cyprus",
  CZ: "Tsjechië",
  DK: "Denemarken",
  DJ: "Djibouti",
  DM: "Dominica",
  DO: "Dominicaanse Republiek",
  EC: "Ecuador",
  EG: "Egypte",
  SV: "El Salvador",
  GQ: "Equatoriaal-Guinee",
  ER: "Eritrea",
  EE: "Estland",
  SZ: "Eswatini",
  ET: "Ethiopië",
  FK: "Falklandeilanden (Malvinas)",
  FO: "Faeröer Eilanden",
  FJ: "Fiji",
  FI: "Finland",
  FR: "Frankrijk",
  GF: "Frans-Guyana",
  PF: "Frans-Polynesië",
  TF: "Franse Zuidelijke Gebieden",
  GA: "Gabon",
  GM: "Gambia",
  GE: "Georgië",
  DE: "Duitsland",
  GH: "Ghana",
  GI: "Gibraltar",
  GR: "Griekenland",
  GL: "Groenland",
  GD: "Grenada",
  GP: "Guadeloupe",
  GU: "Guam",
  GT: "Guatemala",
  GG: "Guernsey",
  GN: "Guinea",
  GW: "Guinea-Bissau",
  GY: "Guyana",
  HT: "Haïti",
  HM: "Heard eiland en McDonaldeilanden",
  VA: "Heilige Stoel",
  HN: "Honduras",
  HK: "Hong Kong",
  HU: "Hongarije",
  IS: "IJsland",
  IN: "India",
  ID: "Indonesië",
  IR: "Iran (Islamitische Republiek)",
  IQ: "Irak",
  IE: "Ierland",
  IM: "Eiland Man",
  IL: "Israël",
  IT: "Italië",
  JM: "Jamaica",
  JP: "Japan",
  JE: "Jersey",
  JO: "Jordanië",
  KZ: "Kazachstan",
  KE: "Kenia",
  KI: "Kiribati",
  KP: "Korea (Democratische Volksrepubliek)",
  KR: "Korea, Republiek van",
  KW: "Koeweit",
  KG: "Kirgizië",
  LA: "Laotiaanse Democratische Volksrepubliek",
  LV: "Letland",
  LB: "Libanon",
  LS: "Lesotho",
  LR: "Liberia",
  LY: "Libië",
  LI: "Liechtenstein",
  LT: "Litouwen",
  LU: "Luxemburg",
  MO: "Macau",
  MG: "Madagaskar",
  MW: "Malawi",
  MY: "Maleisië",
  MV: "Malediven",
  ML: "Mali",
  MT: "Malta",
  MH: "Marshalleilanden",
  MQ: "Martinique",
  MR: "Mauritanië",
  MU: "Mauritius",
  YT: "Mayotte",
  MX: "Mexico",
  FM: "Micronesië (Federale Staten van)",
  MD: "Moldavië, Republiek",
  MC: "Monaco",
  MN: "Mongolië",
  ME: "Montenegro",
  MS: "Montserrat",
  MA: "Marokko",
  MZ: "Mozambique",
  MM: "Myanmar",
  NA: "Namibië",
  NR: "Nauru",
  NP: "Nepal",
  NL: "Nederland",
  NC: "Nieuw-Caledonië",
  NZ: "Nieuw-Zeeland",
  NI: "Nicaragua",
  NE: "Niger",
  NG: "Nigeria",
  NU: "Niue",
  NF: "Norfolk Eiland",
  MK: "Noord-Macedonië",
  MP: "Noordelijke Marianen",
  NO: "Noorwegen",
  OM: "Oman",
  PK: "Pakistan",
  PW: "Palau",
  PS: "Palestina, Staat van",
  PA: "Panama",
  PG: "Papoea-Nieuw-Guinea",
  PY: "Paraguay",
  PE: "Peru",
  PH: "Filippijnen",
  PN: "Pitcairn",
  PL: "Polen",
  PT: "Portugal",
  PR: "Puerto Rico",
  QA: "Qatar",
  RE: "Réunion",
  RO: "Roemenië",
  RU: "Russische Federatie",
  RW: "Rwanda",
  BL: "Sint-Bartholomeus",
  SH: "Sint-Helena, Ascension en Tristan da Cunha",
  KN: "Saint Kitts en Nevis",
  LC: "Saint Lucia",
  MF: "Saint Martin (Franse deel)",
  PM: "Saint Pierre en Miquelon",
  VC: "Saint Vincent en de Grenadines",
  WS: "Samoa",
  SM: "San Marino",
  ST: "Sao Tome en Principe",
  SA: "Saoedi-Arabië",
  SN: "Senegal",
  RS: "Servië",
  SC: "Seychellen",
  SL: "Sierra Leone",
  SG: "Singapore",
  SX: "Sint Maarten (Nederlands deel)",
  SK: "Slowakije",
  SI: "Slovenië",
  SB: "Salomonseilanden",
  SO: "Somalië",
  ZA: "Zuid-Afrika",
  GS: "Zuid-Georgia en de Zuidelijke Sandwicheilanden",
  SS: "Zuid-Soedan",
  ES: "Spanje",
  LK: "Sri Lanka",
  SD: "Soedan",
  SR: "Suriname",
  SJ: "Spitsbergen en Jan Mayen",
  SE: "Zweden",
  CH: "Zwitserland",
  SY: "Syrische Arabische Republiek",
  TW: "Taiwan, Provincie van China",
  TJ: "Tadzjikistan",
  TZ: "Tanzania, Verenigde Republiek",
  TH: "Thailand",
  TL: "Oost-Timor",
  TG: "Togo",
  TK: "Tokelau",
  TO: "Tonga",
  TT: "Trinidad en Tobago",
  TN: "Tunesië",
  TR: "Turkije",
  TM: "Turkmenistan",
  TC: "Turks- en Caicoseilanden",
  TV: "Tuvalu",
  UG: "Oeganda",
  UA: "Oekraïne",
  AE: "Verenigde Arabische Emiraten",
  GB: "Verenigd Koninkrijk van Groot-Brittannië en Noord-Ierland",
  US: "Verenigde Staten van Amerika",
  UM: "Kleine afgelegen eilanden van de Verenigde Staten",
  UY: "Uruguay",
  UZ: "Oezbekistan",
  VU: "Vanuatu",
  VE: "Venezuela (Bolivariaanse Republiek)",
  VN: "Viet Nam",
  VG: "Maagdeneilanden (Brits)",
  VI: "Maagdeneilanden (VS)",
  WF: "Wallis en Futuna",
  EH: "Westelijke Sahara",
  YE: "Jemen",
  ZM: "Zambia",
  ZW: "Zimbabwe",
};
